{
  "helpMessage": "<h3>隐私相关问题？</h3>\n<p>我们的团队乐意协助您 - 请致电：<br/>\n<a><strong>☎️ {{phone}}</strong></a>（然后按 <strong>Option 2</strong>）<br/>\n星期一至星期五，上午8点至下午5点。</p>",
  "privacyDetails": "<ul><li>您了解您的信息将如何被使用。</li><li>您正在为自己或为您有权支持的人完成此预约（例如作为照护者或家长）。</li><li>您同意继续进行预约流程。</li></ul>",
  "privacyLabel": "我接受本隐私声明",
  "privacyText": "通过接受本隐私声明，您确认以下内容：",
  "text": "<p>我们非常重视您的隐私。</p>\n<p>您在此过程中提供的信息将被安全保存，并仅用于支持您在 {{company}} 的治疗和护理。</p>\n<p>您的个人和医疗信息仅会与参与您治疗的医疗专业人员共享。</p>\n<p>我们不会将您的信息用于市场营销，也不会与第三方共享用于此目的。</p>\n<p>您可以随时联系我们，申请访问或更正您的信息。</p>",
  "title": "隐私声明"
}
